export enum HorizontalPositionOption {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right'
}
